import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { IRoadDiagnosticsSegments } from "../../../models/storeModels/IRoadDiagnosticsSegments";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { logout } from "../../../features/auth";

function getInitialState() {
    const initialState: IRoadDiagnosticsSegments = {
        currentRoadDiagnosticsSegment: undefined,
        roadDiagnosticsSegmentsMapYearFilter: getItemWebStorage('diagnosticsYearFilters')?.diagnosticsSegmentsMap ?? [new Date().getFullYear()]
    };
    return initialState;
}


export const roadDiagnosticsSegmentsSlice = createSlice({
    name: 'roadMeasures',
    initialState: getInitialState(),
    reducers: {
        applyYearFilter(state, action: PayloadAction<any>) {
            const { name, value }: any = action.payload;
            state[name as keyof typeof state] = value;
            // Проверяем, является ли name числом
            const parsedYear = parseInt(name, 10);

            if (!isNaN(parsedYear)) {
                // Если значение уже есть в массиве, то удаляем его
                const index = state.roadDiagnosticsSegmentsMapYearFilter.indexOf(parsedYear);
                if (index !== -1 && !value) {
                    state.roadDiagnosticsSegmentsMapYearFilter.splice(index, 1);
                } else if (value) {
                    // Если значения нет в массиве, то добавляем его
                    state.roadDiagnosticsSegmentsMapYearFilter.push(parsedYear);
                }
            }
        },
        setCurrentRoadDiagnosticsSegmentNew(state, action: PayloadAction<any>) {
            state.currentRoadDiagnosticsSegment = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { applyYearFilter, setCurrentRoadDiagnosticsSegmentNew } = roadDiagnosticsSegmentsSlice.actions
export const roadDiagnosticsSegmentsReducer = roadDiagnosticsSegmentsSlice.reducer;
